<template>
  <table cellspacing="0">
    <tbody>
      <tr>
        <td bgcolor="#0000C8">
          <p class="s2" style="text-align: center;">
            <span style="color: #ffffff;"
              ><a name="bookmark0" style="color: #ffffff;"></a>Exostar: Email Updates, Password
              Resets or to Change Security Questions for Systems Using Single Sign On via Exostar
              (e.g., SIP, Activate, SIRIUS, InForm, Impala 2.0, iConnect)</span
            >
          </p>
        </td>
      </tr>
      <tr>
        <td bgcolor="#F1F1F1">
          &nbsp;
          <p class="s6">
            <a href="https://secureaccess.exostar.com/" rel="noopener" target="_blank"
              >Please visit&nbsp;</a
            ><a class="s4" href="https://secureaccess.exostar.com/" rel="noopener" target="_blank"
              >https://secureaccess.exostar.com</a
            >&nbsp;a&nbsp;<span class="s3">nd once logged in navigate to&nbsp;</span>MY ACCOUNT and
            select one of the options on the left. If you select CHANGE EMAIL&nbsp;<span class="s3"
              >and you are a registered SIP user, the change will be automatically reflected in SIP.
              However, we ask that you do let your Pfizer point of contact or site monitor know
              about this change.</span
            >
          </p>
          <p class="s3">
            <a href="#bookmark13">Still need help? Please view the information&nbsp;</a>here.
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    name: 'app-support-exostar-table',
  };
</script>
